function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import link from './link.js';
import requiredImage from '../fragments/requiredImage.js';
var schema = defineObject('researchGroupBadge', {
    action: {
        title: 'Action',
        type: 'link'
    },
    image: _object_spread({
        title: 'Logo / Image'
    }, requiredImage.fragment)
}, [
    link.schema.link
]);
var validator = z.object({
    action: link.validator,
    image: requiredImage.validator
}).partial();
schema.researchGroupBadge;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=researchGroupBadge.js.map